import { useEffect } from 'react';
import { App as AntApp } from 'antd';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { InternalAdminAuthProvider } from './contexts/InternalAdminAuthContext';
import router from './routes';
import { registerNotifier } from './utils/notify';

// Captures the AntD message/notification/modal instance (which is
// scoped to the <AntApp> wrapper from main.jsx) and hands it to the
// notify module. After this mounts, plain utilities — including the
// axios interceptor and any non-React code — can fire popups via
// notify.* without re-entering the React tree.
function NotifyBridge() {
  const { notification, modal, message } = AntApp.useApp();
  useEffect(() => {
    registerNotifier({ notification, modal, message });
  }, [notification, modal, message]);
  return null;
}

export default function App() {
  // Stage 5N-2B: tenant + internal-admin contexts coexist in the same
  // React tree. Each is consumed only by its own protected-route
  // branch, so a tenant page never sees the internal-admin state and
  // vice versa. Token storage is also fully separated — see
  // api/client.js (tenant) and api/internalAdminClient.js (internal).
  return (
    <AuthProvider>
      <InternalAdminAuthProvider>
        <NotifyBridge />
        <RouterProvider router={router} />
      </InternalAdminAuthProvider>
    </AuthProvider>
  );
}
